<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>斐燃生活</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>



    <div class="bb_receiveCoupon">
      <div class="bb_receiveCoupon_newadd" @click="opennewrule()">活动规则</div>
      <div class="bb_receiveCoupon_icon">
        <img :src="sharecouponlogo" />
      </div>
      <div class="bb_receiveCoupon_title">嗨!您的老铁{{source_name}}，送出一张</div>
      <div class="bb_receiveCoupon_coupon">
        <img :src="coupon_bg" />
        <div class="bb_receiveCoupon_coupon_money">
          <!-- <span class="bb_receiveCoupon_coupon_money_icon">¥</span> -->
          <span class="bb_receiveCoupon_coupon_money_word">
            <div class="bb_receiveCoupon_coupon_money_word_icon">¥</div>
            {{source_amount}}
          </span>
          <span class="bb_receiveCoupon_coupon_money_txt">代金券</span>
        </div>
        <div class="bb_receiveCoupon_coupon_desc">
          可直接使用，还能多张叠加使用哦
          <!-- 新用户专享 -->
          <!-- 不但直接抵扣现金，还能多张叠加使用哦~ -->
        </div>
      </div>
      <div class="bb_receiveCoupon_slogin">
        <!-- 全国五星级奢华酒店健身中心<br />
        等您来约!! -->
        <!-- 购买会员卡时可直接抵扣，<br />
        成为斐燃会员，享受五星级酒店高端健身瑜伽服务 -->
        加入斐燃会员<br />
        享受全国精选五星级酒店健身游泳服务

      </div>
      <div class="bb_receiveCoupon_as">
        <!-- 未登录状态 -->
        <div class="bb_receiveCoupon_as_newcoustom" v-show="modules_status==1">
          <div class="bb_receiveCoupon_as_newcoustom_input">
            <label class="bb_receiveCoupon_as_newcoustom_input_tip">+86</label>
            <input v-model="param.mobile" class="bb_receiveCoupon_as_newcoustom_input_tel" type="tel" maxlength="11" placeholder="请输入手机号码" />
          </div>
          <div class="bb_receiveCoupon_as_newcoustom_input bb_receiveCoupon_as_newcoustom_inputcode">
            <input v-model="param.sms_code" class="bb_receiveCoupon_as_newcoustom_input_code" type="tel" maxlength="6" placeholder="请输入验证码" />
            <label class="bb_receiveCoupon_as_newcoustom_input_sms" @click="share_getSms()">{{codeTxt}}</label>
          </div>
          <div class="bb_receiveCoupon_as_newcoustom_regiest" @click="share_getRegiest()">立即领取</div>
          <div class="bb_receiveCoupon_as_bottomtipsf">数量有限，先抢先得</div>
        </div>
        <!-- 已登录未领取 -->
        <div v-show="modules_status==2">
          <div class="bb_receiveCoupon_as_st">
            <img class="bb_receiveCoupon_as_st_bg" :src="coupon_bg_wh" />
            <div class="bb_receiveCoupon_as_st_tx">
              <div class="bb_receiveCoupon_as_st_tx_p">
                <label>¥</label>{{source_amount}}
              </div>
              <div class="bb_receiveCoupon_as_st_tx_t">
                <div class="bb_receiveCoupon_as_st_tx_t_title">{{source_coupon_name}}</div>
                <div class="bb_receiveCoupon_as_st_tx_t_time">有效期至{{source_coupon_endtime}}</div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="bb_receiveCoupon_as_st_tb">限非会员用于开通会员，可多张叠加使用</div>
          </div>
          <div class="bb_receiveCoupon_as_st_lq" @click="receivecoupon()">立即领取</div>
          <div class="bb_receiveCoupon_as_bottomtipsf">数量有限，先抢先得</div>
          <!-- <div class="bb_receiveCoupon_as_st_showcoupon" @click="bbreceiveCouponasstshowcoupon()">
            查看我的优惠券账户<label></label>
          </div> -->
        </div>
        <!-- 已登录已领取 -->
        <div v-show="modules_status==3">
          <div class="bb_receiveCoupon_as_st" >
            <img class="bb_receiveCoupon_as_st_bg" :src="coupon_bg_wh" />
            <div class="bb_receiveCoupon_as_st_tx">
              <div class="bb_receiveCoupon_as_st_tx_p">
                <label>¥</label>{{source_amount}}
              </div>
              <div class="bb_receiveCoupon_as_st_tx_t">
                <div class="bb_receiveCoupon_as_st_tx_t_title">{{source_coupon_name}}</div>
                <div class="bb_receiveCoupon_as_st_tx_t_time">有效期至{{source_coupon_endtime}}</div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="bb_receiveCoupon_as_st_tb">限非会员用于开通会员，可多张叠加使用</div>
          </div>
          <div class="bb_receiveCoupon_as_st_lq" @click="tovip()">立即使用</div>
          <div class="bb_receiveCoupon_as_bottomtipsf">&nbsp;</div>
          <!-- <div class="bb_receiveCoupon_as_st_showcoupon">
            查看我的优惠券账户<label></label>
          </div> -->
        </div>
        <!-- 已经是会员 -->
        <div class="bb_receiveCoupon_alvip" v-show="modules_status==4">
          <img class="bb_receiveCoupon_alvip_img" :src="coupon_bg_vip" />
          <div class="bb_receiveCoupon_alvip_tip">您已经是斐燃会员了，不能再领取了～</div>
          <div class="bb_receiveCoupon_alvip_btn">
            <div @click="toreserve()">我要预约</div>
          </div>
          <div class="bb_receiveCoupon_as_bottomtipsf">&nbsp;</div>
        </div>
        <!-- 已经被领走 -->
        <div class="bb_receiveCoupon_alvip" v-show="modules_status==5">
          <img class="bb_receiveCoupon_alvip_img" :src="coupon_bg_vip" />
          <div class="bb_receiveCoupon_alvip_tip">下手慢了一步，红包已被领走～</div>
          <div class="bb_receiveCoupon_alvip_btn">
            <div @click="toexperiencecardvip()">购买斐燃生活会员卡</div>
          </div>
          <div class="bb_receiveCoupon_as_bottomtipsf">&nbsp;</div>
        </div>
        <!-- 自己查看 -->
        <div class="bb_receiveCoupon_self" v-show="modules_status==6">
          <div class="bb_receiveCoupon_self_title" v-show="recive_avatar">尊敬的会员用户，您的优惠红包已被好友领取</div>
          <div class="bb_receiveCoupon_self_title" v-show="!recive_avatar">尊敬的会员用户，您的优惠红包未被好友领取</div>
          <div class="bb_receiveCoupon_self_info" v-show="recive_avatar">
            <div class="bb_receiveCoupon_self_info_atv" :style="'background-image: url('+recive_avatar_img+')'"></div>
            <div class="bb_receiveCoupon_self_info_inf">
              <div class="bb_receiveCoupon_self_info_inf_name">{{recive_avatar_name}}</div>
              <div class="bb_receiveCoupon_self_info_inf_time">{{recive_avatar_time}}</div>
            </div>
            <div class="clearboth"></div>
          </div>
          <div class="bb_receiveCoupon_self_cou" >
            <img class="bb_receiveCoupon_as_st_bg" :src="coupon_bg_wh" />
            <div class="bb_receiveCoupon_as_st_tx">
              <div class="bb_receiveCoupon_as_st_tx_p">
                <label>¥</label>{{source_amount}}
              </div>
              <div class="bb_receiveCoupon_as_st_tx_t">
                <div class="bb_receiveCoupon_as_st_tx_t_title">{{source_coupon_name}}</div>
                <div class="bb_receiveCoupon_as_st_tx_t_time">有效期至{{source_coupon_endtime}}</div>
              </div>
              <div class="clearboth"></div>
            </div>
            <div class="bb_receiveCoupon_as_st_tb">限非会员用于开通会员，可多张叠加使用</div>
          </div>
          <div class="bb_receiveCoupon_self_toindex">
            <div @click="toindex()">去逛逛</div>
          </div>
          <div class="bb_receiveCoupon_as_bottomtipsf">&nbsp;</div>
        </div>
      </div>
      <div class="bb_receiveCoupon_as_more">
        <div class="bb_receiveCoupon_as_more_title">精选健身服务</div>
        <div class="bb_receiveCoupon_as_more_img">
          <img src="../../assets/images/base/sharecodecouponmore.png" @click="toindex()" />
          <!-- <div class="bb_receiveCoupon_as_more_img_cont">
            <div @click="toreserve()">
              <span>
                更多五星级酒店
              </span>
              <label>&gt;</label>
            </div>
          </div> -->
        </div>

        <!-- <div class="bb_receiveCoupon_as_more_cont">
          <div @click="toindex()">进入斐燃生活</div>
        </div> -->
      </div>
      <!-- 活动介绍 -->
      <!-- <div class="bb_coupon_rulesout" v-show="share_relus_status">
        活动有效期截止到2020年12月31日<br />
        1. 【邀约券】使用规则：<br />
        a.老会员赠送非会员使用； <br />
        b.非会员包括：从未开过卡的新会员和会员已过期的用户； <br />
        c.仅限非会员用于开通会员使用，可多张叠加使用；<br />
        d.一经开卡成为会员，所有来自赠送的未被使用的邀约券都将自动作废； <br />
        e.使用邀约券开卡的用户，若券值大于会员年费，多出的券值将不予返还； <br /><br />
        2. 【会员退订】规则：<br />
        a.所有优惠券，一旦使用都将作废除； <br />
        b.会员开卡后，一旦产生任何使用行为，如：预约、退订、下场、赠送邀约券、使用自用券、领取等，都不可退卡； <br />
        c.会员账户中所有抵用券仅限会员身份有效期内使用，一旦会员过期，账户中所有优惠券都将自动作废（包括已经赠出的邀约券）； <br />
        d.通过邀约券开通会员后，如果退卡，邀请券即作废； <br />
        e.预约订单退订后，如有使用自用券，自用券将退还本人账户； <br />
        f.如会员使用自用券续费，一经退卡，自用券将不予退还。<br /><br />
        3. 该活动由上海合伽技术有限公司保留最终解释权。<br />
      </div> -->
    </div>


    <!-- 弹窗 -->
    <div class="shacouponmask" v-show="newassover" @touchmove.prevent></div>
    <div class="shacouponcont" v-show="newassover" @touchmove.prevent>
      <div class="shacouponcont_cont">
        <div class="shacouponcont_cont_pp">
          <div class="shacouponcont_cont_pp_all">
            <div>
              活动规则
            </div>
            1.活动有效期截止到2020年12月31日；<br />
            2.该代金券由老会员赠送非会员用户，一个非会员用户可领取多张；<br />
            3.非会员包括：从未开过卡的新会员和会员已过期的用户；<br />
            4.好友赠送的代金券仅限非会员用于开通会员使用，可多张叠加使用；<br />
            5.一经开卡成为会员，所有来自赠送的未被使用的代金券都将自动作废；<br />
            6.使用代金券开卡的用户，若券值大于会员年费，多出的券值将不予返还；<br />
            7.代金券若在有效期内未使用，将过期失效不能使用；<br />
            8.若通过代金券开通会员后，如果退卡，代金券即作废；<br />
            9.该活动由上海合伽体育科技有限公司保留最终解释权。<br />
          </div>
        </div>
        <img @click="closenewrule()" src="../../assets/images/base/close_white.png" />
      </div>
    </div>
    <!-- <van-overlay v-show="newassover" :lock-scroll="true">
      <div class="bb_receiveCoupon_as_wrapper">
        <div class="bb_receiveCoupon_as_wrapper_con">
          <div>
            活动有效期截止到2020年12月31日<br />
            1. 【邀约券】使用规则：<br />
            a.老会员赠送非会员使用； <br />
            b.非会员包括：从未开过卡的新会员和会员已过期的用户； <br />
            c.仅限非会员用于开通会员使用，可多张叠加使用；<br />
            d.一经开卡成为会员，所有来自赠送的未被使用的邀约券都将自动作废； <br />
            e.使用邀约券开卡的用户，若券值大于会员年费，多出的券值将不予返还； <br /><br />
            2. 【会员退订】规则：<br />
            a.所有优惠券，一旦使用都将作废除； <br />
            b.会员开卡后，一旦产生任何使用行为，如：预约、退订、下场、赠送邀约券、使用自用券、领取等，都不可退卡； <br />
            c.会员账户中所有抵用券仅限会员身份有效期内使用，一旦会员过期，账户中所有优惠券都将自动作废（包括已经赠出的邀约券）； <br />
            d.通过邀约券开通会员后，如果退卡，邀请券即作废； <br />
            e.预约订单退订后，如有使用自用券，自用券将退还本人账户； <br />
            f.如会员使用自用券续费，一经退卡，自用券将不予退还。<br /><br />
            3. 该活动由上海合伽技术有限公司保留最终解释权。<br />
          </div>
          <img @click="closenewrule()" src="../../assets/visionNew/assets/close_white.png" />
        </div>
      </div>
    </van-overlay> -->
    <!-- <img src="../../assets/images/base/saleover.png" /> -->
  </div>
</template>
<script>
  import {
    isPhone
  } from "../../lib/utils.js"
  export default {
    data() {
      return {
        sharecouponlogo: require('../../assets/images/base/sharecouponlogo.png'),
        logo_home: require('../../assets/images/base/logo_home.png'),
        coupon_bg: require('../../assets/images/base/draw_coupon_couponbg.png'),
        coupon_bg_wh: require('../../assets/images/base/draw_coupon_couponbg_bg.png'),
        coupon_bg_vip: require('../../assets/images/base/coupon_over.png'),
        avlogo:require('../../assets/images/base/dgd1.png'),
        share_relus_status:false,
        sharecode:'',
        modules_status:0,
        source_name:'',
        source_amount:'',
        source_coupon_name:'',
        source_coupon_endtime:'',
        maycard:[],
        userinfo:{},
        recive_avatar:false,
        recive_avatar_img:'',
        recive_avatar_name:'',
        recive_avatar_time:'',
        bb_regiest_tel:'',
        bb_regiest_sms:'',
        codeTxt: "获取验证码",
        param: {
          mobile: "",
          sms_code: ""
        },
        share_openid:'',
        newassover:false
      }
    },
    created() { },
    watch: { },
    mounted() {

      // // console.log(localStorage.getItem('sharecode'))
      this.sharecode=localStorage.getItem('sharecode')
      // this.sharecode='5sed4d45262af5_rZRuX'
      this.getrelusstatus()
      this.totalStatus()
    },
    methods: {
      closenewrule(){
        this.newassover=false
      },
      opennewrule(){
        this.newassover=true
      },
      toexperiencecardvip(){
        this.$router.push({
          name:'vip'
        })
      },
      toreserve(){
        this.$router.push({
          name:'reserve'
        })
      },
      totalStatus(){
        // this.modules_status=5
        // return
        if(localStorage.getItem("token")){
          this.getUerInfo()
        }else{
          // 未登录状态
          this.modules_status=1
          var $this = this
          let param = {
            share_code:this.sharecode
          }
          var qs = require('qs');
          let url = this.api.userApi.couponDetailByShareCode
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            if (result.code == 0) {
              $this.source_name=result.data.detail.user_info.name
              $this.source_amount=result.data.detail.info.amount
              $this.source_coupon_name=result.data.detail.info.name
              $this.source_coupon_endtime=result.data.detail.end_date.replace(/\-/g,".")
              // userinfo
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$loading.close()
            // $this.$toast('error');
          })
        }
      },
      getUerInfo() {
        var $this = this
        if($this.$store.state.object_userinfo==null){
          // console.log(1)
          let param = {
            token: localStorage.getItem("token")
          }
          var qs = require('qs');
          let url = this.api.userApi.getInfo
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            if (result.data) {
              $this.$store.commit('updataMyInfo',result.data.user)
              $this.userinfo = Object.assign({}, result.data.user)
              $this.getviplist()
            } else {
              $this.$toast(result.msg)
            }
          }).catch((error) => {
            console.warn(error)
          })
        }else{
          // console.log(2)
          var currinfo=$this.$store.state.object_userinfo
          $this.userinfo = currinfo
          $this.getviplist()
        }

      },
      getviplist(){
        var $this = this
        // console.log($this.$store.state.list_myCards)
        // $this.$store.commit('setMyCards',result.data.cards)
        // console.log($this.$store.state.list_myCards)

        if($this.$store.state.array_mycard.length==0){
          let param = {
            token: localStorage.getItem("token"),
          }
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            if (result.data) {
              $this.maycard=result.data
              $this.$store.commit('updataMycard', result.data)
              // $this.$store.commit('setMyCards',result.data.cards)
              $this.getdetailcode()
            } else {
              $this.getdetailcode()
              // $this.$toast(result.msg)
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$toast('error');
          })
        }else{
          var curlist=$this.$store.state.array_mycard
          $this.maycard=curlist
          // console.log('result')
          $this.getdetailcode()
        }

      },
      getdetailcode(){
        // couponDetailByShareCode
        var $this = this
        let param = {
          share_code:this.sharecode
        }
        var qs = require('qs');
        let url = this.api.userApi.couponDetailByShareCode
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code == 0) {
            if(result.data.detail==null){
              $this.modules_status=5
              return
            }
            // alert(JSON.stringify(result.data.detail.status))
            $this.source_name=result.data.detail.user_info.name
            $this.source_amount=result.data.detail.info.amount
            $this.source_coupon_name=result.data.detail.info.name
            $this.source_coupon_endtime=result.data.detail.end_date.replace(/\-/g,".")
            if($this.userinfo.user_id==result.data.detail.user_info.user_id){
              $this.modules_status=6
              if(result.data.detail.receive_user_info.avatar){
                $this.recive_avatar=true
                $this.recive_avatar_img=result.data.detail.receive_user_info.avatar
                $this.recive_avatar_name=result.data.detail.receive_user_info.name
                $this.recive_avatar_time=result.data.detail.receive_time
              }
            }else if($this.maycard.length>0){
              $this.modules_status=4
            }else if(result.data.detail.status==1){
              $this.modules_status=2
            }else if(result.data.detail.status==5){
              $this.modules_status=5
            }
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
          // $this.$toast('error');
        })

      },
      receivecoupon(){
        this.$loading('正在领取')
        var $this = this
        let param = {
          token:localStorage.getItem("token"),
          share_code:this.sharecode
        }

        var qs = require('qs');
        let url = this.api.userApi.receiveCoupon
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          $this.$loading.close()
          if (result.code == 0) {
            $this.$toast('领取成功')
            // $this.modules_status=3
            setTimeout(function() {
              $this.$router.push({
                name:'mycoupon'
              })
            }, 500)
          } else {
            $this.$loading.close()
            $this.$toast(result.msg);
            setTimeout(function() {
              $this.$router.go(0)
            }, 500)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$loading.close()
          // $this.$toast('error');
        })

      },
      getrelusstatus(){
        if (localStorage.getItem("token")) {
          this.share_relus_status=true
        } else {
          this.share_relus_status=false
        }
      },
      toindex(){
        this.$router.push({
          path:'/'
        })
      },
      tovip(){
        this.$router.push({
          name:'vip'
        })
      },
      bbreceiveCouponasstshowcoupon(){
        // this.$router.push({
        //   name:'mycoupon'
        // })
        window.location.href="/mycoupon"
      },
      share_getSms(){
        let that = this;
        if (this.codeTxt == "获取验证码") {
          let param = {
            openid: localStorage.getItem("openid"),
            mobile: this.param.mobile
          }
          // getSmsCaptcha
          var qs = require('qs');
          let url = this.api.userApi.getSmsCaptcha
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            that.$toast(result.msg);
            if (result.code == 0) {
              that.codeTxt = "60s";
              let s = 60
              setInterval(function() {
                s -= 1;
                if (s > 0) {
                  that.codeTxt = s + "s";
                }
                if(s == 0){
                  that.codeTxt = "获取验证码";
                  clearInterval();
                }
                // else {
                //   that.codeTxt = "获取验证码";
                //   // clearInterval();
                // }
              }, 1000)
            }
          }).catch((error) => {
            console.warn(error)
            that.$toast(error);
          })
        }
      },
      share_getRegiest(){
        this.$loading('正在登录')
        var $this = this
        if (!isPhone(this.param.mobile)) {
          this.$toast("请输入正确手机号")
          $this.$loading.close()
          return;
        }
        var source = localStorage.getItem("source")
        if (source == null || source == undefined || source == '') {
          this.param.source = '';
        } else {
          this.param.source = source;
        }
        this.param.openid = localStorage.getItem("openid");
        // ============================
        var qs = require('qs');
        let url = this.api.userApi.getLogin
        this.axios.post(url, qs.stringify(this.param), )
        .then((result) => {
          if (result.data) {
            setTimeout(function() {
              $this.$loading.close()
              if(result.code!=0){
                $this.$toast(result.msg)
              }
              localStorage.setItem("token", result.data.token);

              $this.receivecoupon()
              $this.share_relus_status=true
            }, 500)
          } else {
            setTimeout(function() {
              $this.$loading.close()
              $this.$toast(result.msg)
            }, 500)
          }
        }).catch((error) => {
          console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
        // ============================

      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .bb_receiveCoupon{
    width: 100%;
    background-image: url(../../assets/images/base/draw_coupon_bg.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    // padding-bottom: 60*@vm_base;
    position: relative;
    .bb_receiveCoupon_newadd{
      position: absolute;
      top: 0;
      right: 0;
      width:160*@vm_base;
      // height:60*@vm_base;
      // line-height: 60*@vm_base;
      padding: 8*@vm_base 0;
      background:rgba(242,133,66,1);
      border-radius:30*@vm_base 0px 0px 30*@vm_base;
      margin-top: 24*@vm_base;
      text-align: center;
      font-size:26*@vm_base;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    .bb_receiveCoupon_icon{
      width: 160*@vm_base;
      height: 55*@vm_base;
      background:rgba(244,126,47,1);
      border-radius:0px 0px 34*@vm_base 34*@vm_base;
      // opacity:0.35;
      margin: 0 auto;
      img{
        width: 100%;
        // width: 82*@vm_base;
        // margin: 0 auto;
        // padding-top: 13*@vm_base;
      }
    }
    .bb_receiveCoupon_title{
      color: #FFFFFF;
      font-size: 32*@vm_base;
      margin-top: 42*@vm_base;
      margin-bottom: 32*@vm_base;
      width: 100%;
      text-align: center;
    }
    .bb_receiveCoupon_coupon{
      width: 526*@vm_base;
      margin: 0 auto;
      position: relative;
      img{
        width: 100%;
      }
      .bb_receiveCoupon_coupon_money{
        position: absolute;
        top: 0;
        left: 0;
        font-size: 100*@vm_base;
        width: 100%;
        text-align: center;
        color: #E3684C;
        height: 188*@vm_base;
        line-height: 188*@vm_base;
        font-weight: 600;
        padding: 0;
        margin: 0;
        .bb_receiveCoupon_coupon_money_icon{
          font-size: 36*@vm_base;
          padding: 0;
          margin: 0;
          display: inline-block;
          height: 188*@vm_base;
          line-height: 188*@vm_base;
          float: left;
          margin-left: 115*@vm_base;
        }
        .bb_receiveCoupon_coupon_money_word{
          display: inline-block;
          height: 188*@vm_base;
          line-height: 188*@vm_base;
          float: left;
          margin-left: 90*@vm_base;
          text-align: left;
          position: relative;
          .bb_receiveCoupon_coupon_money_word_icon{
            font-size: 36*@vm_base;
            display: inline-block;
            position: absolute;
            bottom: 0;
            left: 0;
            height: 72*@vm_base;
            line-height: 72*@vm_base;
            margin-bottom: 36*@vm_base;margin-left: -24*@vm_base;
          }
        }
        .bb_receiveCoupon_coupon_money_txt{
          display: inline-block;
          font-size: 72*@vm_base;
          height: 188*@vm_base;
          line-height: 188*@vm_base;
          padding: 0;
          margin: 0;
          float: left;
          margin-left: 22*@vm_base;
        }
      }
      .bb_receiveCoupon_coupon_desc{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 0 32*@vm_base;
        color: #CE6446;
        font-size: 24*@vm_base;
        height: 50*@vm_base;
        line-height: 50*@vm_base;
        // text-align: center;
      }
    }
    .bb_receiveCoupon_slogin{
      margin: 32*@vm_base auto;
      width: 100%;
      text-align: center;
      font-size: 28*@vm_base;
      color: #FFFFFF;
      line-height: 40*@vm_base;
    }
    .bb_receiveCoupon_as{
      width: 630*@vm_base;
      margin: 0 auto;

      background-image: url(../../assets/images/base/login_bg.png);
      background-size: 100% auto;
      .bb_receiveCoupon_as_newcoustom{
        padding: 78*@vm_base 32*@vm_base 0*@vm_base 32*@vm_base;
        .bb_receiveCoupon_as_newcoustom_input{
          width: 100%;
          height: 90*@vm_base;
          background: #FFFFFF;
          border-radius: 12*@vm_base;
          padding: 25*@vm_base 32*@vm_base;
          .bb_receiveCoupon_as_newcoustom_input_tip{
            width: 20%;
            display: inline-block;
            height: 40*@vm_base;
            line-height: 40*@vm_base;
            color: #444054;
            font-size: 32*@vm_base;
            text-align: right;
            padding-right: 12*@vm_base;
            border-right: 1*@vm_base solid #999999;
            float: left;
          }
          .bb_receiveCoupon_as_newcoustom_input_tel{
            width: calc(80% - 13*@vm_base);
            height: 40*@vm_base;
            line-height: 40*@vm_base;
            margin-left: 12*@vm_base;
            float: left;
          }
          .bb_receiveCoupon_as_newcoustom_input_code{
            width: 60%;
            height: 40*@vm_base;
            line-height: 40*@vm_base;
            float: left;
          }
          .bb_receiveCoupon_as_newcoustom_input_sms{
            width: 40%;
            height: 40*@vm_base;
            line-height: 40*@vm_base;
            float: left;
            color: #444054;
            font-size: 28*@vm_base;
            text-align: right;
          }
        }
        .bb_receiveCoupon_as_newcoustom_inputcode{
          margin-top: 20*@vm_base;
          margin-bottom: 40*@vm_base;
        }
        .bb_receiveCoupon_as_newcoustom_regiest{
          width:100%;
          height:90*@vm_base;
          line-height: 90*@vm_base;
          text-align: center;
          background:rgba(249,116,86,1);
          border-radius:45*@vm_base;
          font-size:32*@vm_base;
          font-weight:500;
          color:rgba(255,255,255,1);
        }
      }
      .bb_receiveCoupon_as_st{
        width: calc(100% - 64*@vm_base);
        margin-left: 32*@vm_base;
        padding-top: 44*@vm_base;
        position: relative;
        .bb_receiveCoupon_as_st_bg{
          width: 100%;
        }
        .bb_receiveCoupon_as_st_tx{
          position: absolute;
          top: 0;
          left: 0;
          padding-left: 20*@vm_base;
          padding-right: 20*@vm_base;
          padding-top: 64*@vm_base;
          width: 100%;
          .bb_receiveCoupon_as_st_tx_p{
            width: 35%;
            float: left;
            height: 134*@vm_base;
            line-height: 134*@vm_base;
            text-align: center;
            font-size: 72*@vm_base;
            color: #A25138;
            font-weight: 600;
            label{
              font-size: 32*@vm_base;
            }
          }
          .bb_receiveCoupon_as_st_tx_t{
            width: 65%;
            float: left;
            height: 134*@vm_base;
            padding-left: 30*@vm_base;
            .bb_receiveCoupon_as_st_tx_t_title{
              margin-top: 24*@vm_base;
              height: 48*@vm_base;
              line-height: 48*@vm_base;
              color: #666666;
              font-size: 26*@vm_base;
            }
            .bb_receiveCoupon_as_st_tx_t_time{
              height: 38*@vm_base;
              line-height: 38*@vm_base;
              color: #999999;
              font-size: 22*@vm_base;
            }
          }
        }
        .bb_receiveCoupon_as_st_tb{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 60*@vm_base;
          padding: 0 52*@vm_base;
          display: flex;
          // justify-content: center;
          align-items: center;
          color: #B19B91;
          font-size: 22*@vm_base;
        }

      }
      .bb_receiveCoupon_as_st_lq{
        width:calc(100% - 64*@vm_base);
        margin-left: 32*@vm_base;
        height:90*@vm_base;
        line-height: 90*@vm_base;
        background:rgba(249,116,86,1);
        border-radius:45*@vm_base;
        font-size:32*@vm_base;
        font-weight:500;
        color:rgba(255,255,255,1);
        text-align: center;
        margin-top: 40*@vm_base;
        // margin-bottom: 48*@vm_base;
      }
      .bb_receiveCoupon_as_st_showcoupon{
        color: #666666;
        font-size: 24*@vm_base;
        width: 100%;
        height: 48*@vm_base;
        line-height: 48*@vm_base;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        label{
          display: inline-block;
          width: 48*@vm_base;
          height: 48*@vm_base;
          background-image: url(../../assets/images/base/toright.png);
          background-size: 24*@vm_base;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
      .bb_receiveCoupon_alvip{
        .bb_receiveCoupon_alvip_img{
          width: 260*@vm_base;
          margin: 0 auto;
          padding-top: 60*@vm_base;
        }
        .bb_receiveCoupon_alvip_tip{
          width: 426*@vm_base;
          margin: 0 auto;
          margin-top: 40*@vm_base;
          color: #444054;
          font-size: 28*@vm_base;
          line-height: 40*@vm_base;
        }
        .bb_receiveCoupon_alvip_btn{
          width: 100%;
          padding: 60*@vm_base 40*@vm_base 0*@vm_base 40*@vm_base;
          div{
            color: #FFFFFF;
            height: 90*@vm_base;
            line-height: 90*@vm_base;
            text-align: center;
            background:rgba(249,116,86,1);
            border-radius:45*@vm_base;
          }
        }
      }
      .bb_receiveCoupon_self{
        padding: 60*@vm_base 32*@vm_base 0 32*@vm_base;
        .bb_receiveCoupon_self_title{
          font-size: 28*@vm_base;
          color: #444054;
          padding-bottom: 60*@vm_base;
        }
        .bb_receiveCoupon_self_info{
          padding: 0 20*@vm_base;
          .bb_receiveCoupon_self_info_atv{
            width: 70*@vm_base;
            height: 70*@vm_base;
            float: left;
            border: 4*@vm_base solid #FFFFFF;
            border-radius: 50%;
            background-size: 62*@vm_base 62*@vm_base;
            background-position: center center;
            background-repeat: no-repeat;
            margin-bottom: 14*@vm_base;
          }
          .bb_receiveCoupon_self_info_inf{
            width: calc(100% - 70*@vm_base);
            height: 70*@vm_base;
            float: left;
            padding-left: 20*@vm_base;
            .bb_receiveCoupon_self_info_inf_name{
              width: 100%;
              height: 35*@vm_base;
              line-height: 35*@vm_base;
              color: #999999;
              font-weight: 500;
              font-size: 28*@vm_base;
            }
            .bb_receiveCoupon_self_info_inf_time{
              width: 100%;
              height: 35*@vm_base;
              line-height: 35*@vm_base;
              color: #999999;
              font-weight: 400;
              font-size: 22*@vm_base;
            }
          }
        }
        .bb_receiveCoupon_self_cou{
          width: 100%;
          // margin-left: 32*@vm_base;
          // padding-top: 44*@vm_base;
          position: relative;
          .bb_receiveCoupon_as_st_bg{
            width: 100%;
          }
          .bb_receiveCoupon_as_st_tx{
            position: absolute;
            top: 0;
            left: 0;
            padding-left: 20*@vm_base;
            padding-right: 20*@vm_base;
            padding-top: 20*@vm_base;
            width: 100%;
            .bb_receiveCoupon_as_st_tx_p{
              width: 35%;
              float: left;
              height: 134*@vm_base;
              line-height: 134*@vm_base;
              text-align: center;
              font-size: 72*@vm_base;
              color: #A25138;
              font-weight: 600;
              label{
                font-size: 32*@vm_base;
              }
            }
            .bb_receiveCoupon_as_st_tx_t{
              width: 65%;
              float: left;
              height: 134*@vm_base;
              padding-left: 30*@vm_base;
              .bb_receiveCoupon_as_st_tx_t_title{
                margin-top: 24*@vm_base;
                height: 48*@vm_base;
                line-height: 48*@vm_base;
                color: #666666;
                font-size: 26*@vm_base;
              }
              .bb_receiveCoupon_as_st_tx_t_time{
                height: 38*@vm_base;
                line-height: 38*@vm_base;
                color: #999999;
                font-size: 22*@vm_base;
              }
            }
          }
          .bb_receiveCoupon_as_st_tb{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 60*@vm_base;
            padding: 0 52*@vm_base;
            display: flex;
            // justify-content: center;
            align-items: center;
            color: #B19B91;
            font-size: 22*@vm_base;
          }
        }
        .bb_receiveCoupon_self_toindex{
          width: 100%;
          padding: 60*@vm_base 40*@vm_base 0*@vm_base 40*@vm_base;
          div{
            width:100%;
            height:90*@vm_base;
            line-height: 90*@vm_base;
            background:rgba(249,116,86,1);
            border-radius:45*@vm_base;
            text-align: center;
            font-size:32*@vm_base;
            font-weight:500;
            color:rgba(255,255,255,1);
          }
        }
      }
      .bb_coupon_rules{
        color: #B19183;
        padding: 60*@vm_base 32*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 400;
        line-height: 40*@vm_base;
      }
      .bb_receiveCoupon_as_bottomtipsf{
        height: 88*@vm_base;
        line-height: 88*@vm_base;
        text-align: center;
        width: 100%;
        font-size: 24*@vm_base;
        color: #8F8C98;
        margin-bottom: 8*@vm_base;
      }
    }
    .bb_receiveCoupon_as_more{
      width: 100%;
      padding: 0 60*@vm_base 80*@vm_base 60*@vm_base;
      // img{
      //   width: 100%;
      // }
      .bb_receiveCoupon_as_more_title{
        width:100%;
        font-size:32*@vm_base;
        font-weight:400;
        color:rgba(68,64,84,1);
        text-align: center;
        height: 113*@vm_base;
        line-height: 113*@vm_base;
        margin-top: 30*@vm_base;
      }
      .bb_receiveCoupon_as_more_img{
        width: 100%;
        position: relative;
        img{
          width: 100%;
        }
        .bb_receiveCoupon_as_more_img_cont{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 92*@vm_base;
          div{
            width: 260*@vm_base;
            height: 46*@vm_base;
            border-radius:23*@vm_base;
            border:1*@vm_base solid rgba(68,64,84,1);
            text-align: center;

            font-size:24*@vm_base;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height:46*@vm_base;
            span{
              margin-left: 35*@vm_base;
              display: inline-block;
              height: 44*@vm_base;
              line-height: 44*@vm_base;
              float: left;
            }
            label{
              display: inline-block;
              float: left;
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              font-size: 36*@vm_base;
            }
          }
        }
      }
      .bb_receiveCoupon_as_more_cont{
        height: 60*@vm_base;
        width: 100%;
        margin-top: 40*@vm_base;
        div{
          margin: 0 auto;
          width: 280*@vm_base;
          height: 60*@vm_base;
          background:rgba(68,64,84,1);
          border-radius:32*@vm_base;
          font-size:28*@vm_base;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:60*@vm_base;
          text-align: center;

        }
      }
    }
    .bb_coupon_rulesout{
      width: 630*@vm_base;
      margin: 0 auto;
      padding: 32*@vm_base;
      background-image: url(../../assets/images/base/login_bg.png);
      background-size: 100% auto;
      color: #B19183;
      font-size: 24*@vm_base;
      font-weight: 400;
      line-height: 40*@vm_base;
    }

  }
  .bb_receiveCoupon_as_wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .bb_receiveCoupon_as_wrapper_con{
      max-height: 80vh;
      width: 80%;
      // background: #FFFFFF;
      // overflow: hidden;
      div{
        background: #FFFFFF;
        border-radius: 12*@vm_base;
        padding: 60*@vm_base 40*@vm_base;
        max-height:calc(80vh - 64*@vm_base);
        overflow: hidden;
        overflow-y: auto;
      }
      img{
        margin: 0 auto;
        margin-top: 60*@vm_base;
        width: 64*@vm_base;
      }
    }
  }
  .shacouponmask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    background: #000000;
    opacity: 0.7;
    z-index: 66;
  }
  .shacouponcont{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 67;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .shacouponcont_cont{
      width: 80%;
      // border: 1px solid red;
      .shacouponcont_cont_pp{
        padding: 32*@vm_base;
        background: #FFFFFF;
        border-radius: 12*@vm_base;
        .shacouponcont_cont_pp_all{
          max-height: 70vh;
          overflow: hidden;
          overflow-y: auto;
          color:rgba(51,51,51,0.8);
          font-size: 24*@vm_base;
          font-weight: normal;
          line-height: 40*@vm_base;
          div{
            font-weight: normal;
            width: 100%;
            text-align: center;
            color: #333333;
            font-size: 32*@vm_base;
            margin-bottom: 20*@vm_base;
          }
        }
      }
      img{
        margin: 0 auto;
        margin-top: 60*@vm_base;
        width: 64*@vm_base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sharecoupon/sharecoupon.vue